<template>
  <div>
    <b-row>
      <b-col cols="12">
        <brands-filter :get-report-data="getBrands" />
      </b-col>
      <b-col
        v-if="loading"
        cols="12"
      >
        <loading-card />
      </b-col>
      <b-col
        v-else
        cols="12"
      >
        <b-row class="match-height">
          <b-col cols="12">
            <primary-heading
              title-text="Genel Toplam"
            />
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <default-card
              title="Satışlar"
              :value="brands.grandTotal.sales"
              icon="CheckCircleIcon"
              color="success"
              to-page="/sales/sales"
            />
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <default-new-card
              title="Bağlantılar"
              title1="Stok Bağlantı"
              title2="Tahsis Bağlantı"
              :value="brands.grandTotal.connections"
              :value1="brands.grandTotal.stockConnections"
              :value2="brands.grandTotal.allocateConnections"
              icon="LinkIcon"
              color="info"
              to-page="/sales/connections"
            />
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <default-card
              title="Stoklar"
              :value="brands.grandTotal.stocks"
              icon="CodesandboxIcon"
              color="warning"
              to-page="/sales/stocks"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="12"
            md="4"
          >
            <pie-charts
              chart-title="Satışlar"
              chart-type="donut"
              :series-data="brands.grandTotal.salesChart.series"
              :categories-data="brands.grandTotal.salesChart.categories"
              :colors-data="brands.grandTotal.salesChart.colors"
            />
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <pie-charts
              chart-title="Bağlantılar"
              chart-type="donut"
              :series-data="brands.grandTotal.connectionsChart.series"
              :categories-data="brands.grandTotal.connectionsChart.categories"
              :colors-data="brands.grandTotal.connectionsChart.colors"
            />
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <pie-charts
              chart-title="Stoklar"
              chart-type="donut"
              :series-data="brands.grandTotal.stocksChart.series"
              :categories-data="brands.grandTotal.stocksChart.categories"
              :colors-data="brands.grandTotal.stocksChart.colors"
            />
          </b-col>
        </b-row>
        <b-row
          v-for="brand in brands.data"
          :key="brand.id"
          class="match-height"
        >
          <b-col cols="12">
            <primary-heading
              :title-text="brand.title"
              title-class="text-secondary"
            />
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <default-card
              title="Satışlar"
              :value="brand.sales"
              icon="CheckCircleIcon"
              color="success"
              to-page="/sales/sales"
            />
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <default-new-card
              title="Bağlantılar"
              title1="Stok Bağlantılar"
              title2="Tahsis Bağlantılar"
              :value="brand.connections"
              :value1="brand.stockConnections"
              :value2="brand.allocateConnections"
              icon="LinkIcon"
              color="info"
              to-page="/sales/connections"
            />
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <default-card
              title="Stoklar"
              :value="brand.stocks"
              icon="CodesandboxIcon"
              color="warning"
              to-page="/sales/stocks"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { BRow, BCol, BCard } from 'bootstrap-vue'
import BrandsFilter from '@/views/Sales/FilterCards/BrandsFilter.vue'
import DefaultCard from '@/layouts/components/ReportCards/DefaultCard.vue'
import PrimaryHeading from '@/layouts/components/PrimaryHeading.vue'
import LoadingCard from '@/layouts/components/Loading.vue'
import DefaultNewCard from '@/layouts/components/ReportCards/DefaultNewCard.vue'
import PieCharts from '@/layouts/components/ReportCharts/PieCharts.vue'

export default {
  name: 'Sales',
  components: {
    DefaultNewCard,
    LoadingCard,
    BrandsFilter,
    DefaultCard,
    PrimaryHeading,
    PieCharts,
    BRow,
    BCol,
    BCard,
  },
  computed: {
    loading() {
      return this.$store.getters['saleReports/loading']
    },
    brands() {
      return this.$store.getters['saleReports/brands']
    },
    brandsParams() {
      return this.$store.getters['saleReports/brandsParams']
    },
    chartData() {
      return this.$store.getters['saleReports/getChartData']
    },
  },
  created() {
    this.getBrands()
  },
  methods: {
    getBrands() {
      this.$store.dispatch('saleReports/getBrands', this.brandsParams)
    },
  },
}
</script>
